export default __webpack_public_path__ + "static/char-s-58-zh-Hans-6086cd555b982959bb857d0f129c1d5f.webp";